<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import Input from "../../components/Form/Fields/Input.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import Button from "../../components/Button.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import {
    initDetail,
    record,
    save,
    onPlantSelected,
    onSrcCustomerSelected,
    fillCustomerExtras,
    onSrcTransportDocumentSelected,
  } from "./butcher-section.store";
  import type { IButcherSection } from "../../entities/butcher-section";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import DateInputString from "../../components/Form/Fields/DateInputString.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import CustomerDropdown from "../../components/Business/CustomerDropdown.svelte";
  import CarrierDropdown from "../../components/Business/CarrierDropdown.svelte";
  import RoomTypeDropdown from "../../components/Business/RoomTypeDropdown.svelte";
  import PlantDropdown from "../../components/Business/PlantDropdown.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import ButcherSectionItemsFragment from "./ButcherSectionItemsFragment.svelte";
  import CustomerAddressDropdown from "../../components/Business/CustomerAddressDropdown.svelte";
  import { get } from "svelte/store";
  import { CustomerService } from "../../services/customer.service";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
  //import CustomerCod317Dropdown from "../../components/Business/CustomerCod317Dropdown.svelte";
  import CustomerQuickCreate from "../Customer/CustomerQuickCreate.svelte";
  import type { ICustomerQuickCreateResponseDTO } from "../../services/DTO/customer-quick-create-response-dto";
  import Label from "../../components/Form/Label.svelte";
  import TransportDocumentForSectionDropdown from "../../components/Business/TransportDocumentForSectionDropdown.svelte";

  export let oid: number;

  let customerQuickCreateVisible: boolean = false;

  $: isNew = oid == 0;
  $: canSubmit =
    $record != null &&
    $record.originCode != "" &&
    !!$record.plantId &&
    !!$record.roomTypeId &&
    !!$record.srcTransportDocumentId &&
    !!$record.srcCustomerId &&
    !!$record.dstCustomerId &&
    !!$record.dstCustomerAddressId;
  $: canEdit = $record != null;
  // $: showDichUsoDomestico =
  //   !isNew && $currentSrcCustomer != null && $currentSrcCustomer.ownCompany == 1 && $currentUtilizationCode != null && $currentUtilizationCode == "PRIVATOXXX";

  enum SectionPage {
    General = 1,
    Products,
  }

  let currentTab: SectionPage = SectionPage.General;

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IButcherSection> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/butcher-work/section/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/butcher-work/section`);
  }

  async function onDstCustomerSelected(evt: CustomEvent<IDropdownItem>) {
    try {
      let r = get(record);
      if (r == null) return;
      let customerId = evt.detail.oid;
      if (!customerId) return;
      let cust = await CustomerService.getCustomerAddresses(customerId);
      let defaultAddressId: number | null = null;
      if (cust != null && cust.payload != null) {
        let ids = cust.payload.filter((x) => x.headquarters == 1).map((x) => x.oid);
        if (!!ids && ids.length > 0) defaultAddressId = ids[0];
      }

      r.dstCustomerAddressId = defaultAddressId!;
      record.set(r);
    } catch (err) {
      onDstCustomerClear(null!);
    }
  }
  async function onDstCustomerClear(_evt: CustomEvent<any>) {
    let r = get(record);
    if (r == null) return;
    r.dstCustomerAddressId = null!;
    record.set(r);
  }

  function onCustomerQuickCreate_Show() {
    customerQuickCreateVisible = true;
  }
  async function onCustomerQuickCreate_Created(evt: CustomEvent<ICustomerQuickCreateResponseDTO>) {
    let c: ICustomerQuickCreateResponseDTO = evt.detail;
    let r = get(record);
    r = { ...r!, srcCustomerId: c.customerId, dstCustomerId: c.customerCod317Id, dstCustomerAddressId: c.customerAddressId };
    record.set(r);
    await fillCustomerExtras(c.customerId, false);
    customerQuickCreateVisible = false;
  }
  function onCustomerQuickCreate_Cancel() {
    customerQuickCreateVisible = false;
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Generale"
      active={currentTab == SectionPage.General}
      on:click={(_) => {
        currentTab = SectionPage.General;
      }}
    />

    {#if !isNew}
      <Tab
        label="Prodotti"
        active={currentTab == SectionPage.Products}
        on:click={(_) => {
          currentTab = SectionPage.Products;
        }}
      />
    {/if}
  </Tabs>

  {#if $record}
    <!-- GENERAL -->
    {#if currentTab == SectionPage.General}
      {#if customerQuickCreateVisible}
        <CustomerQuickCreate on:create={onCustomerQuickCreate_Created} on:cancel={onCustomerQuickCreate_Cancel} />
      {:else}
        <!--
      {#if isNew == false}
        <div class="card slaughter-status-panel">
          <div class="card-content">
            <div class="slaughter-status-message">
              {#if $record.working == 0 && $record.completed == 0}
                <h2>Lavorazione da avviare</h2>
                <Button on:click={(_) => startWork()}>Avvia Lavorazione</Button>
              {/if}
              {#if $record.working == 1}
                <h2>Lavorazione in corso</h2>
                <Button on:click={(_) => stopWork()}>Termina Lavorazione</Button>
              {/if}
              {#if $record.working == 0 && $record.completed == 1}
                <h2>Lavorazione completata</h2>
              {/if}
            </div>
          </div>
        </div>
      {/if}
      -->

        <div class="columns">
          <div class="column is-12">
            <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
              <div class="columns">
                <div class="column is-4">
                  <FormField>
                    <PlantDropdown
                      name="Stabilimento"
                      placeholder=""
                      required={true}
                      disabled={!isNew}
                      farmPlant={0}
                      bind:value={$record.plantId}
                      on:select={(v) => onPlantSelected(v.detail)}
                    />
                  </FormField>
                </div>
                <div class="column is-4">
                  <FormField>
                    <DateInputString name="Data Sezionamento" placeholder="" required={false} disabled={!canEdit} bind:value={$record.workingDate} />
                  </FormField>
                </div>
                <div class="column is-4">
                  <FormField>
                    <!-- <Input name="Protocollo" placeholder="" required={false} disabled={true} bind:value={$record.protocol} /> -->
                    <NumberInput name="Num. giornaliero" disabled={!canEdit} bind:value={$record.dailyNumber} />
                  </FormField>
                </div>
              </div>

              <div class="columns">
                <div class="column is-3">
                  <FormField>
                    <TransportDocumentForSectionDropdown
                      name="DDT ingresso"
                      required={true}
                      disabled={!isNew}
                      bind:value={$record.srcTransportDocumentId}
                      on:select={(v) => onSrcTransportDocumentSelected(v.detail)}
                    />
                  </FormField>
                </div>
                <!--
                <div class="column is-2">
                  <FormField klass="has-text-right">
                    <Switch name="Trasporto a caldo" bind:value={$record.hotTransportExecuted} />
                  </FormField>
                </div>
                <div class="column is-2">
                  <FormField klass="has-text-right">
                    <Switch name="Trasporto con mezzo refrigerato" bind:value={$record.hotTransportCooled} />
                  </FormField>
                </div>
                <div class="column is-2">
                  <FormField klass="has-text-right">
                    <Switch name="TRC" bind:value={$record.trc} />
                  </FormField>
                </div>
                -->
                <!--
                <div class="column is-2">
                  <FormField klass="has-text-right">
                    <Switch name="DDT automatico" bind:value={$record.autoDdt} />
                  </FormField>
                </div>
                -->
                <div class="column is-2">
                  <FormField klass="has-text-right">
                    <Switch name="Attiva" bind:value={$record.active} />
                  </FormField>
                </div>
              </div>

              <!--
            <div class="columns">
              <div class="column is-4">
                <FormField>
                  <NumberInput name="Numero capi" placeholder="num capi" required={false} disabled={true} bind:value={$record.totQuantity} />
                </FormField>
              </div>
              <div class="column is-4">
                <FormField>
                  <NumberInput name="P.V. Totale [Kg]" placeholder="p.v. totale" required={true} bind:value={$record.totWeight} />
                </FormField>
              </div>
              <div class="column is-4">
                <FormField>
                  <NumberInput name="P.V. Medio [Kg]" placeholder="p.v. medio" required={false} disabled={true} bind:value={$record.avgWeight} />
                </FormField>
              </div>
            </div>
            -->

              <div class="columns">
                <div class="column is-3">
                  <FormField>
                    <ClfDropdown name="Origine" placeholder="origine" schema="RAISINGTYP" required={true} bind:value={$record.clfRaisingTypeId} />
                  </FormField>
                </div>
                <!--
                <div class="column is-3">
                  <FormField>
                    <Input name="Mod. 4" placeholder="mod4" required={true} bind:value={$record.mod4Number} />
                  </FormField>
                </div>
                -->
                <div class="column is-3">
                  <FormField>
                    <ClfDropdown name="Scopo" placeholder="scopo" schema="PURPOSEXXX" required={true} bind:value={$record.clfPurposeId} />
                  </FormField>
                </div>
                <div class="column is-3">
                  <FormField>
                    <RoomTypeDropdown
                      name="Stoccaggio"
                      required={true}
                      plantId={$record.plantId}
                      phaseCode={$record.phaseCode}
                      bind:value={$record.roomTypeId}
                    />
                  </FormField>
                </div>
              </div>

              <!--
              <div class="columns">
                <div class="column is-3">
                  <FormField>
                    <ClfDropdown
                      name="Utilizzo"
                      placeholder="utilizzo"
                      schema="UTILIZATIO"
                      required={true}
                      bind:value={$record.clfUtilizationId}
                      on:select={(v) => onUtilizationSelected(v.detail)}
                    />
                  </FormField>
                </div>
                <div class="column is-3">
                  <FormField>
                    <Input name="Note Utilizzo" placeholder="note utilizzo" required={false} bind:value={$record.utilizationNotes} />
                  </FormField>
                </div>
                <div class="column is-3">
                  <FormField>
                    <ClfDropdown
                      name="Tipo lavorazione"
                      placeholder="tipo lavorazione"
                      schema="SLAUPROCTY"
                      required={false}
                      bind:value={$record.clfProcessingTypeId}
                    />
                  </FormField>
                </div>
              </div>
              -->

              <div class="columns">
                <div class="column is-6">
                  <FormField>
                    {#key $record.srcCustomerId}
                      <CustomerDropdown
                        name="Provenienza"
                        required={true}
                        bind:value={$record.srcCustomerId}
                        on:select={(v) => onSrcCustomerSelected(v.detail)}
                      />
                    {/key}
                  </FormField>
                </div>
                <!--
                <div class="column is-3">
                  {#key $record.srcCustomerId}
                    <FormField>
                      <CustomerCod317Dropdown
                        name="Cod. 317"
                        required={true}
                        clearVisible={false}
                        customerId={$record.srcCustomerId ?? 0}
                        bind:value={$record.srcCod317Id}
                      />
                    </FormField>
                  {/key}
                </div>
                -->
                <!--
              <div class="column is-4">
                <FormField>
                  <CarrierDropdown name="Vettore Prov." required={false} clearVisible={true} bind:value={$record.srcCarrierId} />
                </FormField>
              </div>
              -->
                <div class="column is-3">
                  <FormField>
                    <Label>&nbsp;</Label>
                    <Button on:click={onCustomerQuickCreate_Show}>Nuovo Cliente</Button>
                  </FormField>
                </div>
              </div>

              <!--
            <div class="columns">
              <div class="column is-3">
                <FormField>
                  <Input name="N° DDT" placeholder="" required={false} bind:value={$record.srcDdtNumber} />
                </FormField>
              </div>
              <div class="column is-3">
                <FormField>
                  <DateInputString name="Data DDT" placeholder="" required={false} bind:value={$record.srcDdtDate} />
                </FormField>
              </div>
              <div class="column is-3">
                <FormField>
                  <Input name="N° Fattura" placeholder="" required={false} bind:value={$record.srcInvoiceNumber} />
                </FormField>
              </div>
              <div class="column is-3">
                <FormField>
                  <DateInputString name="Data Fattura" placeholder="" required={false} bind:value={$record.srcInvoiceDate} />
                </FormField>
              </div>
            </div>
            -->

              <div class="columns">
                <div class="column is-6">
                  <FormField>
                    {#key $record.dstCustomerId}
                      <CustomerDropdown
                        name="Destinazione"
                        required={true}
                        bind:value={$record.dstCustomerId}
                        on:select={onDstCustomerSelected}
                        on:clear={onDstCustomerClear}
                      />
                    {/key}
                  </FormField>
                </div>
                <div class="column is-6">
                  <FormField>
                    {#key $record.dstCustomerId}
                      <CustomerAddressDropdown
                        name="Indirizzo Destinazione"
                        required={true}
                        clearVisible={false}
                        customerId={$record.dstCustomerId ?? 0}
                        bind:value={$record.dstCustomerAddressId}
                      />
                    {/key}
                  </FormField>
                </div>
              </div>

              <!--
              <div class="columns">
                <div class="column is-6">
                  <FormField>
                    <CarrierDropdown name="Vettore Dest." required={false} clearVisible={true} bind:value={$record.dstCarrierId} />
                  </FormField>
                </div>
              </div>
              -->

              <!--
            <div class="columns">
              <div class="column is-3">
                <FormField>
                  <Input name="N° DDT" placeholder="" required={false} bind:value={$record.dstDdtNumber} />
                </FormField>
              </div>
              <div class="column is-3">
                <FormField>
                  <DateInputString name="Data DDT" placeholder="" required={false} bind:value={$record.dstDdtDate} />
                </FormField>
              </div>
              <div class="column is-3">
                <FormField>
                  <Input name="N° Fattura" placeholder="" required={false} bind:value={$record.dstInvoiceNumber} />
                </FormField>
              </div>
              <div class="column is-3">
                <FormField>
                  <DateInputString name="Data Fattura" placeholder="" required={false} bind:value={$record.dstInvoiceDate} />
                </FormField>
              </div>
            </div>
            -->

              <div class="columns">
                <div class="column is-12">
                  <FormField>
                    <Textarea name="Note" placeholder="note interne" required={false} bind:value={$record.notes} />
                  </FormField>
                </div>
              </div>

              <!--
              <div slot="other_buttons" class="control">
                {#key showDichUsoDomestico}
                  {#if showDichUsoDomestico}
                    <Button klass="is-warning" on:click={(_) => downloadDichiarazioneUsoDomesticoReport()}>Dichiarazione uso domestico</Button>
                  {/if}
                {/key}
              </div>
              -->
            </FormLayout>
          </div>
        </div>
        <!-- end quick create -->
      {/if}
    {/if}

    <!-- PRODUCTS -->
    {#if currentTab == SectionPage.Products}
      <ButcherSectionItemsFragment sectionId={$record.oid}></ButcherSectionItemsFragment>
    {/if}
  {/if}
</MainLayout>

<style>
  /*
  .slaughter-status-panel {
    text-align: center;
    width: 40%;
    min-width: 600px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;
  }
  .slaughter-status-message h2 {
    color: #dd1111;
    font-weight: bold;
  }
    */
</style>
